<HomeNavBar />
<div class="container-fluid p-2 pb-extra product-view-shell bg-white shadow-sm  position-relative">
       <!-- BACK BUTTON -->
    <button
      @click="go_back"
      class="btn btn-light rounded-circle p-2 d-flex align-items-center justify-content-center back-btn"
    >
      <i class="bi bi-chevron-left fs-5"></i>
    </button>
  <div
    v-if="loading"
    class="marketplace-loader-wrap d-flex align-items-center justify-content-center"
    role="status"
    aria-live="polite"
  >
    <div class="marketplace-loader-card">
      <div class="marketplace-loader-orbit">
        <span
          class="marketplace-loader-ring marketplace-loader-ring-primary"
        ></span>
        <span
          class="marketplace-loader-ring marketplace-loader-ring-secondary"
        ></span>
        <span
          class="marketplace-loader-core d-flex align-items-center justify-content-center"
        >
          <i class="bi bi-box-seam fs-1 text-primary"></i>
        </span>
        <span class="marketplace-loader-dot marketplace-loader-dot-one"></span>
        <span class="marketplace-loader-dot marketplace-loader-dot-two"></span>
      </div>
      <p class="marketplace-loader-title mb-1">Loading...</p>
      <p class="marketplace-loader-copy mb-0">
        We’re fetching the details for you.
      </p>
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div v-else-if="page_error" class="row justify-content-center py-5">
    <div class="col-lg-8">
      <div class="card border-0 shadow-sm rounded-4 p-5 text-center">
        <h4 class="fw-bold text-dark mb-2">Product unavailable</h4>
        <p class="text-muted mb-3">{{ page_error }}</p>
        <router-link
          :to="{ name: 'Marketplace' }"
          class="btn btn-primary rounded px-4"
        >
          Back to Marketplace
        </router-link>
      </div>
    </div>
  </div>

  <div v-else-if="product" class=" ">
 
 <div v-if="product.product_type.name === 'product'">
    <!-- CONTENT -->
  <div class="row g-3 align-items-stretch product-view-main-row mb-4 mt-4">
        <div class="col-md-6 d-flex flex-column">
        <div
          class="product-view-gallery product-view-main-panel overflow-hidden position-relative rounded w-100"
          @touchstart.passive="handle_gallery_touch_start"
          @touchend.passive="handle_gallery_touch_end"
          @pointerdown="handle_gallery_pointer_start"
          @pointerup="handle_gallery_pointer_end"
          @pointercancel="clear_gallery_pointer"
        >
          <!-- Image -->
          <div class="ratio ratio-1x1 rounded">
            <img
              :src="selected_image?.image_url"
              :alt="product.name"
              class="product-view-main-image d-block"
            />
          </div>

          <!-- Prev button -->
          <button
            v-if="product_images.length > 1"
            class="btn bg-transparent position-absolute top-50 start-0 translate-middle-y ms-2 shadow-sm"
            @click="prev_image"
          >
            <i class="bi bi-chevron-left"></i>
          </button>
          <!-- Next button -->
          <button
            v-if="product_images.length > 1"
            class="btn bg-transparent position-absolute top-50 end-0 translate-middle-y me-2 shadow-sm"
            @click="next_image"
          >
            <i class="bi bi-chevron-right"></i>
          </button>
        </div>

        <div
          v-if="product.description || show_product_reviews"
          class="product-view-description-block my-3"
        >
          <p
            v-if="product.description"
            class="text-muted lh-lg product-view-description mb-0"
          >
            {{ product.description }}
          </p>
          <div
            v-else-if="show_product_reviews"
            class="product-view-description-placeholder"
            aria-hidden="true"
          ></div>
        </div>

        <div
          v-if="product_images.length > 1"
          class="d-flex gap-1 p-3 border-rounded overflow-auto"
        >

            <img
              v-for="(image, index) in product_images"
              :key="index"
              :src="image.image_url"
              :alt="product.name + ' thumbnail ' + (index + 1)"
              class="btn p-0 border rounded-3 overflow-hidden ad-image pointer border-transparent"
              :class="active_image_index === index ? 'border-primary border-2' : 'border-light'"
            @click="set_active_image(index)"
            />
        </div>

      </div>

      <div class="col-md-6 d-flex flex-column">
        <div
          class="product-view-summary d-flex flex-column"
          :class="{ 'product-view-main-panel': !show_product_reviews }"
        >
          <div class="mb-3">
            <span class="product-view-eyebrow mb-2 d-inline-flex">Product</span>
            <h3 class="fw-bold text-dark mb-2 product-view-title">
              {{ product.name }}
            </h3>
            <p class="text-muted mb-3">
              Supplied by
              <span
                class="fw-semibold text-primary pointer"
                @click="view_profile(product.base_profile)"
                >{{ get_company_name(product) }}</span
              >
            </p>
            <p class="fw-bold text-dark mb-0 product-view-price">
              R {{ format_price(display_price(product)) }}
            </p>
          </div>

          <div v-if="required_attribute_groups.length" class="mb-4">
            <div
              v-for="group in required_attribute_groups"
              :key="group.key"
              class="mb-3"
            >
              <div class="d-flex align-items-center gap-2 mb-2">
                <span class="fw-semibold text-dark"
                  >{{ group.label || group.key }}</span
                >
                <span
                  v-if="attribute_errors[group.key]"
                  class="text-danger small"
                >
                  {{ attribute_errors[group.key] }}
                </span>
              </div>

              <div class="d-flex flex-wrap gap-2">
                <button
                  v-for="attr in group.values"
                  :key="attr.id"
                  type="button"
                  class="btn rounded px-3"
                  :class="selected_attributes[group.key] === attr.id ? 'btn-dark' : 'btn-outline-secondary'"
                  @click="select_attribute(group.key, attr)"
                >
                  {{ attr.value }}
                </button>
              </div>
            </div>
          </div>

          <div class="d-flex align-items-center gap-3 mb-4">
            <span class="fw-semibold text-dark">Quantity</span>
            <div
              class="d-inline-flex align-items-center border rounded overflow-hidden"
            >
              <button
                type="button"
                class="btn btn-link text-dark text-decoration-none px-3"
                @click="decrease_quantity"
              >
                -
              </button>
              <span class="px-2 fw-semibold">{{ selected_quantity }}</span>
              <button
                type="button"
                class="btn btn-link text-dark text-decoration-none px-3"
                @click="increase_quantity"
              >
                +
              </button>
            </div>
          </div>

          <div class="d-flex flex-row gap-2 gap-sm-3 mb-4">
            <button
              type="button"
              class="btn marketplace-modal-btn rounded px-2 px-sm-4 py-2 flex-fill"
              :disabled="adding_to_cart || buying_now"
              @click="add_current_product_to_cart"
            >
              <span
                v-if="adding_to_cart"
                class="spinner-border spinner-border-sm me-2"
                role="status"
              ></span>
              Add to Cart
            </button>

            <button
              type="button"
              class="btn btn btn-primary rounded px-2 px-sm-4 py-2 flex-fill"
              :disabled="adding_to_cart || buying_now"
              @click="buy_now"
            >
              <span
                v-if="buying_now"
                class="spinner-border spinner-border-sm me-2"
                role="status"
              ></span>
              Buy Now
            </button>
          </div>

          <div class="mt-4 pt-3">
            <div class="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-3">
              <div>
                <p class="fw-bold text-dark mb-1">Ratings & Reviews</p>
                <div class="d-flex align-items-center gap-2 flex-wrap">
                  <span class="fw-bold text-dark">
                    {{ product?.average_rating ? Number(product.average_rating).toFixed(1) : '0.0' }}
                  </span>
                  <div class="d-flex gap-1">
                    <i
                      v-for="n in 5"
                      :key="`summary-star-${n}`"
                      class="bi"
                      :class="n <= Math.round(Number(product?.average_rating || 0)) ? 'bi-star-fill text-primary' : 'bi-star text-muted'"
                    ></i>
                  </div>
                  <span class="text-muted small">
                    {{ product_reviews.length }} {{ product_reviews.length === 1 ? 'review' : 'reviews' }}
                  </span>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-link p-0 text-decoration-none fw-semibold text-primary"
                @click="toggle_product_reviews"
              >
                {{ show_product_reviews ? 'Hide Reviews' : 'View Reviews' }}
              </button>
            </div>
          </div>

        </div>
        <div v-if="show_product_reviews" class="card border bg-light rounded shadow-sm p-3 product-view-reviews-panel">
          <div class="mb-3">
            <div>
              <h6 class="fw-bold text-dark mb-1">Ratings & Reviews</h6>
              <p class="text-muted small mb-0">See what customers are saying about this product.</p>
            </div>
          </div>

          <div
            v-if="(product?.can_review && !has_submitted_product_review) || is_editing_product_review"
            class="card border bg-white rounded p-3 mb-3"
          >
            <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2 mb-3">
              <div>
                <h6 class="fw-bold text-dark mb-1">{{ is_editing_product_review ? 'Edit Your Review' : 'Write a Review' }}</h6>
                <p class="text-muted small mb-0">How was your experience with this product?</p>
              </div>
              <p class="text-muted small mb-0">{{ rating_level }}</p>
            </div>

            <div class="d-flex align-items-center gap-2 mb-3">
              <i
                v-for="n in 5"
                :key="`new-star-${n}`"
                class="pointer"
                :class="n <= (hover_rating || new_rating) ? 'bi bi-star-fill text-primary' : 'bi bi-star text-secondary'"
                @mouseenter="hover_rating = n"
                @mouseleave="hover_rating = 0"
                @click="new_rating = n"
              ></i>
            </div>

            <textarea
              v-model="product_review_text"
              class="form-control form-control-sm mb-3 rounded"
              rows="4"
              placeholder="Share your thoughts - quality, value, reliability..."
            ></textarea>

            <div class="d-flex justify-content-end gap-2">
              <button
                v-if="is_editing_product_review"
                class="btn btn-outline-secondary btn-sm fw-semibold rounded px-4"
                @click="cancel_edit_product_review"
              >
                Cancel
              </button>
              <button
                class="btn btn-primary btn-sm fw-semibold rounded px-4"
                :disabled="!new_rating || !product_review_text.trim()"
                @click="submit_product_review"
              >
                {{ is_editing_product_review ? 'Update Review' : 'Submit Review' }}
              </button>
            </div>
          </div>

          <div
            v-else-if="has_submitted_product_review && !is_editing_product_review"
            class="alert alert-success d-flex align-items-center gap-2 py-2 small rounded mb-3"
          >
            <i class="bi bi-check-circle-fill"></i>
            Your review has already been submitted.
          </div>

          <div
            v-else-if="product && !product?.can_review"
            class="alert d-flex align-items-center gap-2 py-2 small rounded mb-3"
          >
            <i class="bi bi-info-circle"></i>
            You can only review products after they have been delivered.
          </div>

          <div v-if="product_reviews.length === 0" class="text-center py-3 text-muted small">
            No reviews yet. Be the first!
          </div>

          <div
            v-else
            class="d-flex flex-column gap-2 overflow-auto pe-1"
            style="max-height: 420px;"
          >
            <div
              v-for="(review, index) in product_reviews"
              :key="`product-review-${index}`"
              class="card border bg-white rounded p-3"
            >
              <div class="d-flex flex-column flex-sm-row justify-content-between gap-2 mb-2">
                <div>
                  <div class="d-flex align-items-start justify-content-between gap-3">
                    <div class="fw-bold text-dark small">
                      {{
                        review?.base_profile?.company?.company_name
                        || `${review?.base_profile?.user?.first_name || ''} ${review?.base_profile?.user?.last_name || ''}`.trim()
                        || 'User'
                      }}
                    </div>
                    <div v-if="review_belongs_to_current_user(review)" class="dropdown flex-shrink-0">
                      <button class="btn btn-sm btn-link text-muted p-0 shadow-none" data-bs-toggle="dropdown">
                        <i class="bi bi-three-dots"></i>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-end shadow-sm border-0 rounded-3">
                        <li>
                          <a class="dropdown-item small" href="#" @click.prevent="open_edit_product_review(review)">
                            Edit
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="d-flex gap-1 mt-1">
                    <i
                      v-for="star in 5"
                      :key="`review-star-${index}-${star}`"
                      class="bi"
                      :class="star <= review.rating ? 'bi-star-fill text-primary' : 'bi-star text-muted'"
                    ></i>
                  </div>
                </div>
                <div class="text-muted small">{{ format_date(review.created_at) }}</div>
              </div>

              <p class="text-muted small mb-0">{{ review.review }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="recommendations.length"
      class="product-view-recommendations px-2 mt-2"
    >
      <div class="d-flex align-items-center justify-content-between mb-3 ">
        <div>
          <p class="fw-bold text-dark mb-1">Recommended Products</p>
        </div>
      </div>

      <div
        v-if="recommendations.length"
        class="product-recommendations-scroll d-flex flex-nowrap"
      >
        <div
          v-for="recommended in recommendations"
          :key="recommended.id"
          class="product-recommendation-item"
        >
          <div
            class="marketplace-product-card h-100 d-flex flex-column bg-light shadow-sm"
            @click="view_recommended_product(recommended)"
          >
            <div class="ratio ratio-1x1 rounded bg-light">
              <img
                :src="recommended.images?.[0]?.image_url"
                :alt="recommended.name"
                class="w-100 h-100 marketplace-card-image"
              />
            </div>
            <div class="card-body d-flex flex-column p-2">
              <span
                class="text-muted text-truncate text-xs small mb-1"
              >
                {{ get_company_name(recommended) }}
              </span>
              <span
                class="fw-bold text-dark mb-1 text-xs text-truncate small"
              >
                {{ recommended.name }}</span
              >
              <span
                class="fw-bold text-xs small"
              >
                R {{ format_price(display_price(recommended)) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>


  <div v-else-if="product.product_type?.name === 'service' && show_service_view">
  <div class="row g-3 align-items-stretch product-view-main-row mb-4 mt-4">
        <!-- LEFT: IMAGE + DETAILS -->
        <div class="col-md-6 d-flex flex-column">
          <!-- MAIN IMAGE -->
          <div
            class="product-view-gallery overflow-hidden position-relative"
            @touchstart.passive="handle_gallery_touch_start"
            @touchend.passive="handle_gallery_touch_end"
            @pointerdown="handle_gallery_pointer_start"
            @pointerup="handle_gallery_pointer_end"
            @pointercancel="clear_gallery_pointer"
          >
            <div>
              
              <img
                :src="selected_image?.image_url"
                class="product-view-main-image d-block"
                :alt="product?.name || 'Service Image'"
              />
            </div>
            <!-- Prev button -->
            <button
              v-if="product_images.length > 1"
              class="btn text-white position-absolute top-50 start-0 translate-middle-y ms-2 shadow-sm"
              @click="prev_image"
            >
              <i class="bi bi-chevron-left"></i>
            </button>
            <!-- Next button -->
            <button
              v-if="product_images.length > 1"
              class="btn text-white position-absolute top-50 end-0 translate-middle-y me-2 shadow-sm"
              @click="next_image"
            >
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>

          <!-- DETAILS -->
          <h4 class="fw-bold text-dark mt-3 mb-1">{{ product?.name }}</h4>

          <p class="text-muted mb-2">
            Offered by
            <span class="fw-semibold text-primary">
              {{ get_company_name(product) }}
            </span>
          </p>

          <!-- LOCATION -->
          <div class="mb-3">
            <div
              v-if="product?.service_details?.type_name === 'drop_in'"
              class="d-flex align-items-center gap-2 small"
            >
              <i class="bi bi-geo-alt-fill text-primary"></i>
              <span>
                <strong>Location:</strong>
                {{ product?.service_details.location }}
              </span>
            </div>

            <div
              v-else-if="product?.service_details?.type_name === 'on_site'"
              class="d-flex align-items-center gap-2 text-muted small"
            >
              <i class="bi bi-info-circle-fill text-info"></i>
              <span> Please provide the service address in the form. </span>
            </div>
          </div>

          <h5 class="fw-bold text-dark mb-3">
            R{{ format_price(display_price(product)) }}
          </h5>

          <!-- DESCRIPTION -->
          <div class="product-view-description-block">
            <div
              v-if="product?.description"
              class="text-muted small lh-lg quill-content product-view-description mb-0"
              v-html="product?.description"
            ></div>
            <div
              v-else
              class="product-view-description-placeholder"
              aria-hidden="true"
            ></div>
          </div>
          <!-- THUMBNAILS -->
          <div
            v-if="product.images?.length > 1"
            class="d-flex gap-2 overflow-auto pb-2"
          >
            <button
              v-for="(image, index) in product.images"
              :key="index"
              class="btn p-0 border rounded-3 overflow-hidden ad-image pointer"
              :class="active_image_index === index ? 'border-primary border-2' : 'border-light'"
              @click="set_active_image(index)"
            >
              <img
                :src="image.image_url"
                class="object-fit-contain marketplace-card-image"
              />
            </button>
          </div>

        </div>

        <!-- RIGHT: FORM -->
        <div class="col-12 col-lg-6">
          <div class="d-flex flex-column gap-3">
          <div
            class="card border-2 border-primary bg-white rounded-4 shadow-sm p-3 d-flex flex-column py-4"
          >
            <h6 class="text-center fw-bold text-dark mb-3">
              Request a Service
            </h6>

            <!-- DATE -->
            <div class="mb-3">
              <label class="small fw-bold text-dark mb-2 d-block ms-1">
                Preferred Date
              </label>
              <input
                type="datetime-local"
                class="form-control border-1 border-primary rounded bg-light"
                v-model="service_request.date"
                :min="min_date"
                step="60"
                @input="sync_service_request_field('date')"
                @change="sync_service_request_field('date')"
              />
              <p v-if="errors.service_date" class="text-danger text-xxs mt-1 mb-0">
                {{ errors.service_date }}
              </p>
            </div>

            <!-- CONTACT -->
            <div class="row g-3 mb-3">
              <div class="col-12 col-md-6">
                <label class="small fw-bold text-dark mb-2 d-block ms-1">Email Address</label>
                <input
                  type="email"
                  class="form-control border-1 border-primary rounded bg-light"
                  v-model="service_request.email"
                  placeholder="your@email.com"
                  autocomplete="email"
                  autocapitalize="off"
                  autocorrect="off"
                  spellcheck="false"
                  @input="sync_service_request_field('email')"
                />
                <p v-if="errors.email" class="text-danger text-xxs mt-1 mb-0">
                  {{ errors.email }}
                </p>
              </div>

              <div class="col-12 col-md-6">
                <label class="small fw-bold text-dark mb-2 d-block ms-1">Phone Number</label>
                <input
                  type="tel"
                  class="form-control border-1 border-primary rounded bg-light"
                  v-model="service_request.contact_number"
                  placeholder="012 345 6789"
                  autocomplete="tel"
                  inputmode="tel"
                  @input="sync_service_request_field('contact_number')"
                />
                <p v-if="errors.contact_number" class="text-danger text-xxs mt-1 mb-0">
                  {{ errors.contact_number }}
                </p>
              </div>
            </div>

            <!-- ADDRESS -->
            <div
              v-if="service_request?.service_details?.type_name === 'on_site'"
              class="mb-3"
            >
              <label class="small fw-bold text-dark mb-2 d-block ms-1">
                Street Address
              </label>
              <input
                type="text"
                ref="marketplaceLocationInput"
                class="form-control border-1 border-primary rounded bg-light"
                v-model="service_request.location"
                placeholder="Start typing your physical address..."
                @input="sync_service_request_field('location')"
              />
              <p v-if="errors.location" class="text-danger text-xxs mt-1 mb-0">
                {{ errors.location }}
              </p>
            </div>

            <!-- NOTES -->
            <div class="mb-3">
              <label class="small fw-bold text-dark d-block ms-1">
                Additional Notes
              </label>
              <textarea
                class="form-control border-1 border-primary rounded bg-light"
                v-model="service_request.message"
                rows="5"
                placeholder="Tell us more about your requirements..."
              ></textarea>
            </div>

            <!-- SUBMIT -->
            <button
              type="button"
              class="btn btn-primary w-100 fw-bold py-2 rounded shadow-sm"
              :disabled="isLoading"
              @click="submit_service_request"
            >
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              Book Service
            </button>
          </div>
          <div class="card border bg-light rounded shadow-sm p-3">
            <div class="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-3">
              <div>
                <p class="fw-bold text-dark mb-1">Ratings & Reviews</p>
                <div class="d-flex align-items-center gap-2 flex-wrap">
                  <span class="fw-bold text-dark">
                    {{ product?.average_rating ? Number(product.average_rating).toFixed(1) : '0.0' }}
                  </span>
                  <div class="d-flex gap-1">
                    <i
                      v-for="n in 5"
                      :key="`service-summary-star-${n}`"
                      class="bi"
                      :class="n <= Math.round(Number(product?.average_rating || 0)) ? 'bi-star-fill text-primary' : 'bi-star text-muted'"
                    ></i>
                  </div>
                  <span class="text-muted small">
                    {{ product_reviews.length }} {{ product_reviews.length === 1 ? 'review' : 'reviews' }}
                  </span>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-link p-0 text-decoration-none fw-semibold text-primary"
                @click="toggle_product_reviews"
              >
                {{ show_product_reviews ? 'Hide Reviews' : 'View Reviews' }}
              </button>
            </div>
          </div>

          <div v-if="show_product_reviews" class="card border bg-light rounded shadow-sm p-3 product-view-reviews-panel">
            <div class="mb-3">
              <div>
                <h6 class="fw-bold text-dark mb-1">Ratings & Reviews</h6>
                <p class="text-muted small mb-0">See what customers are saying about this service.</p>
              </div>
            </div>

          <div
            v-if="(product?.can_review && !has_submitted_product_review) || is_editing_product_review"
            class="card border bg-white rounded p-3 mb-3"
          >
            <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2 mb-3">
              <div>
                  <h6 class="fw-bold text-dark mb-1">{{ is_editing_product_review ? 'Edit Your Review' : 'Write a Review' }}</h6>
                  <p class="text-muted small mb-0">How was your experience with this service?</p>
                </div>
                <p class="text-muted small mb-0">{{ rating_level }}</p>
              </div>

              <div class="d-flex align-items-center gap-2 mb-3">
                <i
                  v-for="n in 5"
                  :key="`service-new-star-${n}`"
                  class="pointer"
                  :class="n <= (hover_rating || new_rating) ? 'bi bi-star-fill text-primary' : 'bi bi-star text-secondary'"
                  @mouseenter="hover_rating = n"
                  @mouseleave="hover_rating = 0"
                  @click="new_rating = n"
                ></i>
              </div>

              <textarea
                v-model="product_review_text"
                class="form-control form-control-sm mb-3 rounded"
                rows="3"
                placeholder="Share your thoughts - quality, communication, value..."
              ></textarea>

              <div class="d-flex justify-content-end gap-2">
                <button
                  v-if="is_editing_product_review"
                  class="btn btn-outline-secondary btn-sm fw-semibold rounded px-4"
                  @click="cancel_edit_product_review"
                >
                  Cancel
                </button>
                <button
                  class="btn btn-primary btn-sm fw-semibold rounded px-4"
                  :disabled="!new_rating || !product_review_text.trim()"
                  @click="submit_product_review"
                >
                  {{ is_editing_product_review ? 'Update Review' : 'Submit Review' }}
                </button>
              </div>
            </div>

            <div
              v-else-if="has_submitted_product_review && !is_editing_product_review"
              class="alert alert-success d-flex align-items-center gap-2 py-2 small rounded mb-3"
            >
              <i class="bi bi-check-circle-fill"></i>
              Your review has already been submitted.
            </div>

            <div
              v-else-if="product && !product?.can_review"
              class="alert d-flex align-items-center gap-2 py-2 small rounded mb-3"
            >
              <i class="bi bi-info-circle"></i>
              You can only review services after they have been completed.
            </div>

            <div v-if="product_reviews.length === 0" class="text-center py-3 text-muted small">
              No reviews yet. Be the first!
            </div>

            <div
              v-else
              class="d-flex flex-column gap-2 overflow-auto pe-1"
              style="max-height: 420px;"
            >
              <div
                v-for="(review, index) in product_reviews"
                :key="`service-review-${index}`"
                class="card border bg-white rounded p-3"
              >
                <div class="d-flex flex-column flex-sm-row justify-content-between gap-2 mb-2">
                  <div>
                    <div class="d-flex align-items-start justify-content-between gap-3">
                      <div class="fw-bold text-dark small">
                        {{
                          review?.base_profile?.company?.company_name
                          || `${review?.base_profile?.user?.first_name || ''} ${review?.base_profile?.user?.last_name || ''}`.trim()
                          || 'User'
                        }}
                      </div>
                      <div v-if="review_belongs_to_current_user(review)" class="dropdown flex-shrink-0">
                        <button class="btn btn-sm btn-link text-muted p-0 shadow-none" data-bs-toggle="dropdown">
                          <i class="bi bi-three-dots"></i>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end shadow-sm border-0 rounded-3">
                          <li>
                            <a class="dropdown-item small" href="#" @click.prevent="open_edit_product_review(review)">
                              Edit
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="d-flex gap-1 mt-1">
                      <i
                        v-for="star in 5"
                        :key="`service-review-star-${index}-${star}`"
                        class="bi"
                        :class="star <= review.rating ? 'bi-star-fill text-primary' : 'bi-star text-muted'"
                      ></i>
                    </div>
                  </div>
                  <div class="text-muted small">{{ format_date(review.created_at) }}</div>
                </div>

                <p class="text-muted small mb-0">{{ review.review }}</p>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    <div v-if="recommendations.length" class="product-view-recommendations px-2">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <div>
          <p class="fw-bold text-dark mb-1">Recommended Services</p>
        </div>
      </div>

      <div v-if="recommendations.length" class="product-recommendations-scroll d-flex flex-nowrap">
        <div
          v-for="recommended in recommendations"
          :key="recommended.id"
          class="product-recommendation-item"
        >
          <div
            class="marketplace-product-card h-100 d-flex flex-column bg-light shadow-sm"
            @click="view_recommended_product(recommended)"
          >
            <div class="ratio ratio-1x1 rounded bg-light">
              <img
                :src="recommended.images?.[0]?.image_url"
                :alt="recommended.name"
                class="w-100 h-100 marketplace-card-image"
              />
            </div>
            <div class="card-body d-flex flex-column p-2">
              <span class="text-muted text-truncate text-xs small mb-1">
                {{ get_company_name(recommended) }}
              </span>
              <span class="fw-bold text-dark mb-1 text-xs text-truncate small"
                >{{ recommended.name }}</span
              >
              <span class="fw-bold text-xs small">
                R {{ format_price(display_price(recommended)) }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div
        v-else-if="!loading_recommendations"
        class="card border-0 bg-light rounded-4 p-4 text-center"
      >
        <p class="text-muted mb-0">
          No recommendations available for this product yet.
        </p>
      </div>
    </div>
  </div>
  </div>
</div>
